import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ConsentService } from '@app/services/consent.service';

export const consentGuard: CanActivateFn = () => {
  return inject(ConsentService).ensureConsent();
};
